/** @module Classes */ /** typedoc */

import {
    IntensityEnum,
    MasteringStyleEnum,
    StateMasteringEnum,
    TrackTypeEnum,
} from '../enums';
import { State } from './State';
import { LibraryAsset } from './LibraryAsset';

/**
 *  Represent an Album Object that can be built from an AlbumAsset (MSLibrary)
 */
export class Album extends LibraryAsset {
    trackType = TrackTypeEnum.Album;
    collaborators: Array<any> = []; // Should probably not be here (deep model) but Falcor map All assets with collaborators by default, TBD
    canAddFormats = false;
}

/**
 * Represent an Album Item and it contains the common properties of an AlbumOriginal and an AlbumVersion
 */
export class AlbumItem {
    id: string = null;
    creationDate: string = null;
    isAtLeastCdAudioQuality: boolean = null;
    constructor() {}
}

/**
 * Represent an albumOriginal Item and will be part of an Album Object
 */
export class AlbumOriginal extends AlbumItem {
    tracksOrder: Array<string> = [];

    constructor() {
        super();
    }
}

/**
 * Represent an albumVersion Item and will be part of an Album Object
 */
export class AlbumVersion extends AlbumItem {
    intensity: IntensityEnum = null;
    creationState: State<StateMasteringEnum> = null;
    canAddFormats = true;
    engineVersion: string = null;
    style: MasteringStyleEnum = null;

    constructor() {
        super();
    }
}
